<script setup>
import { computed, ref, watch } from "vue";
import { Loading } from "@element-plus/icons-vue";
import { storeToRefs } from "pinia";
import { useLayoutStore } from "@/stores/layout";
import { getEvaluateList } from "@/api/dashboard";

const layoutStore = useLayoutStore();
const { reportDialog } = storeToRefs(layoutStore);

const visible = computed({
  get: () => !!reportDialog.value.dialog,
  set: (v) => {
    if (!v) layoutStore.closeReportDialog();
    else layoutStore.openReportDialog();
  },
});

const testReport = ref([]);
const isLoading = ref(false);

function formatTitle(title) {
  return String(title || "")
    .replace("Result", "")
    .trim();
}

async function load() {
  isLoading.value = true;
  try {
    const data = await getEvaluateList();
    const charts = data?.chartsData || [];
    testReport.value = charts.filter((item) => item.CatName !== "TESOL");
  } catch {
    testReport.value = [];
  } finally {
    isLoading.value = false;
  }
}

watch(visible, (open) => {
  if (open) load();
});
</script>

<template>
  <el-dialog
    v-model="visible"
    width="900px"
    class="qa-report-dialog"
    :show-close="true"
    align-center
  >
    <div class="cu-trail-class">
      <div class="chart-title">QA Test Report</div>
      <div v-if="isLoading" class="progress-loading">
        <el-icon class="is-loading" :size="40"><Loading /></el-icon>
      </div>
      <div v-else class="test-report-content">
        <div
          v-for="(item, index) in testReport"
          :key="index"
          class="test-report-card"
        >
          <div class="test-report-text">
            <span>{{ formatTitle(item.CatName) }}:</span>
            <span class="score">{{ item.AllScore }}</span>
          </div>
          <el-progress
            :percentage="Math.min(100, Number(item.AllScore) || 0)"
            :stroke-width="6"
            :show-text="false"
            color="#3E67FB"
          />
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<style scoped lang="scss">
.cu-trail-class {
  padding: 8px 10px 20px;
}
.chart-title {
  font-weight: 700;
  font-size: 24px;
  text-align: center;
  margin-bottom: 16px;
  color: var(--app-text, $blue-title);
}
.progress-loading {
  display: flex;
  justify-content: center;
  padding: 80px 0;
  color: #999;
}
.test-report-content {
  overflow: hidden;
}
.test-report-card {
  width: 48%;
  float: left;
  margin-bottom: 14px;
  color: var(--app-text, $blue-title);
  &:nth-child(even) {
    float: right;
  }
  .score {
    margin-left: 3px;
  }
}
:deep(.el-progress-bar__outer) {
  background-color: rgba(125, 162, 255, 0.19);
}
</style>
